module.exports = __webpack_public_path__ + "img/2-4.e10274ae.png";